// extracted by mini-css-extract-plugin
module.exports = {"cardSlider":"components-CardSlider-CardSlider__cardSlider--2Xu96","loadingCard":"components-CardSlider-CardSlider__loadingCard--2fJyu"};